import { createQuery } from 'effector-apollo'

import client from 'src/apollo/client'

import { IS_AUTHENTICATED_QUERY } from './graphql'

export const isAuthenticatedQuery = createQuery({
  document: IS_AUTHENTICATED_QUERY,
  context: { isSkipError: true },
  client,
})
